<template>
  <div class="pa-0 ma-0 chat-page-container">
    <!-- Policy Gate: User muss Reglement akzeptieren -->
    <ChatPolicyDialog v-if="showPolicyDialog" :value="showPolicyDialog" @accepted="onPolicyAccepted" />

    <template v-if="!showPolicyDialog">
      <v-row no-gutters class="fill-height chat-container">
        <v-col cols="12" md="4" v-if="!isMobileChatOpen" class="group-list-col d-flex flex-column">
          <ChatGroupList
            :has-create-right="hasCreateRight"
            :has-direct-chat-right="hasDirectChatRight"
            @open-broadcast-dialog="showBroadcastDialog = true"
            @open-create-dialog="showCreateDialog = true"
            @open-direct-dialog="showDirectDialog = true" />
        </v-col>

        <v-col cols="12" md="8" v-if="activeView === 'pinboard' && !activeGroupId" class="message-view-col d-flex flex-column" key="pinboard">
          <PinboardView @jump-to-message="handlePinJump" />
        </v-col>

        <v-col cols="12" md="8" v-else-if="activeGroupId" class="message-view-col d-flex flex-column" :key="'chat-' + activeGroupId">
          <ChatMessageView ref="chatMessageView" />
        </v-col>

        <v-col md="8" v-if="$vuetify.breakpoint.mdAndUp && !activeGroupId && activeView !== 'pinboard'" class="message-view-col d-flex flex-column">
          <v-container class="fill-height" fluid>
            <v-row align="center" justify="center" class="fill-height">
              <v-col cols="12" class="text-center grey--text">
                <v-icon size="80" color="grey darken-2">mdi-chat-processing-outline</v-icon>
                <p class="mt-4 headline">Wähle eine Gruppe aus</p>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <UserProfileDialog />
      <BroadcastDialog v-model="showBroadcastDialog" />
      <chat-group-create-dialog v-if="hasCreateRight" v-model="showCreateDialog" @group-created="showCreateDialog = false" />
      <chat-direct-create-dialog v-if="hasDirectChatRight" v-model="showDirectDialog" @chat-started="showDirectDialog = false" />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import userService from "@/services/userService"

import ChatGroupList from "./components/chatGroupList.vue"
import ChatMessageView from "./components/chatMessageView.vue"
import ChatGroupCreateDialog from "./components/chatGroupCreateDialog.vue"
import ChatDirectCreateDialog from "./components/chatDirectCreateDialog.vue"
import UserProfileDialog from "./components/userProfileDialog.vue"
import BroadcastDialog from "./components/chatBroadcastDialog.vue"
import PinboardView from "./components/pinboardView.vue"
import ChatPolicyDialog from "./components/chatPolicyDialog.vue"

export default {
  name: "ChatView",
  components: {
    ChatGroupList,
    BroadcastDialog,
    ChatMessageView,
    ChatGroupCreateDialog,
    ChatDirectCreateDialog,
    UserProfileDialog,
    PinboardView,
    ChatPolicyDialog,
  },

  data() {
    return {
      showBroadcastDialog: false,
      showCreateDialog: false,
      showDirectDialog: false,
      policyAccepted: false,
    }
  },

  created() {
    // Prüfe ob User die Policy schon akzeptiert hat
    const stored = JSON.parse(localStorage.getItem("user") || "{}")
    if (stored.user && stored.user.chatPolicyAcceptedAt) {
      this.policyAccepted = true
    }
  },

  computed: {
    ...mapState("chatStore", ["activeGroupId", "activeView"]),

    isMobileChatOpen() {
      return !this.$vuetify.breakpoint.mdAndUp && (this.activeGroupId || this.activeView === "pinboard")
    },

    hasCreateRight() {
      return userService.hasRight("chat_create") || this.hasDirectChatRight
    },

    hasDirectChatRight() {
      return userService.hasRight("chat_admin") || userService.hasRight("chat_centermanager") || userService.hasRight("chat_my_centermanager")
    },
    showPolicyDialog() {
      return !this.policyAccepted
    },
  },

  watch: {
    activeGroupId(val) {
      if (val) this.pushHistoryState()
    },
    activeView(val) {
      if (val === "pinboard") this.pushHistoryState()
    },
  },

  mounted() {
    window.addEventListener("popstate", this.handlePopState)
  },

  beforeDestroy() {
    window.removeEventListener("popstate", this.handlePopState)
  },

  methods: {
    // FIX 3: Store-Actions korrekt mappen
    ...mapActions("chatStore", {
      setActiveGroup: "setActiveGroup",
      // Wir benennen die Action um, um Namenskonflikte zu vermeiden
      dispatchJumpToMessage: "jumpToMessage",
    }),

    pushHistoryState() {
      if (window.history.state && window.history.state.chatOpen) return
      window.history.pushState({ chatOpen: true }, "")
    },

    handlePopState(event) {
      if (this.activeGroupId || this.activeView === "pinboard") {
        this.setActiveGroup(null)
      }
    },

    /**
     * FIX 4: Die korrigierte Jump-Logik
     * Nutzt das gleiche System wie die Suche!
     */
    async handlePinJump(pin) {
      // Pinboard liefert manchmal das Wrapper-Objekt oder direkt die Message
      const message = pin.originalPin || pin
      // Sicherstellen, dass wir die ID haben
      const groupId = message.groupId._id || message.groupId

      // 1. Gruppe öffnen (wechselt View auf 'chat')
      await this.setActiveGroup(groupId)

      // 2. Store Action aufrufen (Läd bei Bedarf die History-Seite nach)
      // Das ist der entscheidende Teil, der gefehlt hat!
      const success = await this.dispatchJumpToMessage(message)

      // 3. Scrollen und Highlighten
      if (success) {
        // Wir warten kurz (nextTick), bis ChatMessageView gerendert ist
        this.$nextTick(() => {
          const chatView = this.$refs.chatMessageView
          if (chatView && chatView.scrollToMessage) {
            chatView.scrollToMessage(message._id)
          } else {
            console.warn("ChatMessageView Ref nicht gefunden oder Methode fehlt")
          }
        })
      }
    },

    onPolicyAccepted() {
      this.policyAccepted = true
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-container {
  height: 100vh;
  overflow: hidden;
}

.group-list-col,
.message-view-col {
  height: 100%;
  overflow: hidden;
}

.group-list-col {
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
